import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`

:root {
    --global-font-size: 62.5%;
    --global-width: 160rem;
    --global-lineheight: 1.5;

    // Colors
    --primary-color: #F06600;
    --primary-color-light: #ff9e57;
    --light-grey: #E2E1DD;
    --grey: #9C9B96;
    --medium-grey: #9C9B96;
    --dark-grey: #555552;
    --black: #0d0b0f;
    --white: #fff;
    --bright-red: #ff5252;
    --facebook: #3b5998;
    --body-background: white;
    --body-font-color: black;



    --heading-font-family: 'caslon-graphique', Georgia, serif;
    --body-font-family: 'Jernhusen Sans', Arial, sans-serif;
    --body-antialiased: true;
    --global-margin: 2rem;
    --global-padding: 2rem;
    --global-weight-light: 300;
    --global-weight-normal: 500;
    --global-weight-medium: 500;
    --global-weight-bold: 800;
    --global-radius: 3px;
    --global-text-direction: ltr;
    --global-flexbox: false;
    --print-transparent-backgrounds: true;
}

`